// src/components/SharePointSearch/SharePointNoResults.tsx

import * as React from "react";
import { NormalizedSharePointSearch } from "../../interfaces/sharepointSearchTypes";
import { WarningIcon } from "./SharePointIcons";
import { spColors } from "./sharepointSearchStyles";

interface SharePointNoResultsProps {
  result: NormalizedSharePointSearch;
}

/**
 * Displayed when a SharePoint search returns 0 results.
 * Shows a warning box with the original query and actionable search tips.
 */
const SharePointNoResults: React.FC<SharePointNoResultsProps> = ({ result }) => {
  const tips = [
    "Try different keywords or phrases",
    "Check your document permissions",
    "Verify the SharePoint library is connected",
    "Use fewer or more general terms",
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "8px",
          padding: "10px 12px",
          borderRadius: "6px",
          backgroundColor: spColors.warningBg,
          fontSize: "12px",
          lineHeight: "1.5",
          color: spColors.warningColor,
        }}
      >
        <WarningIcon />
        <span>
          Your search for &ldquo;{result.originalQuery}&rdquo; didn&rsquo;t match any SharePoint
          documents
        </span>
      </div>

      <ul
        style={{
          margin: 0,
          paddingLeft: "20px",
          fontSize: "11px",
          color: spColors.mutedForeground,
          lineHeight: "1.8",
        }}
      >
        {tips.map((tip, idx) => (
          <li key={idx}>{tip}</li>
        ))}
      </ul>
    </div>
  );
};

export default SharePointNoResults;
